const BLOCK_GAP = 5;

export default BLOCK_GAP;
